"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.US_STATE_TERRITORY_CODES = exports.US_TERRITORY_CODES = exports.US_STATE_CODES = exports.US_STATE_NAME_TO_CODE = exports.US_STATE_CODE_TO_NAME = void 0;
const lodash_1 = require("lodash");
const sort_1 = require("../sort");
/**
 * A map of state codes to states in the form: AK: 'Alaska'
 * Includes US Territories as well as states
 */
exports.US_STATE_CODE_TO_NAME = Object.freeze({
    AK: 'Alaska',
    AL: 'Alabama',
    AR: 'Arkansas',
    AS: 'American Samoa',
    AZ: 'Arizona',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DC: 'District of Columbia',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    GU: 'Guam',
    HI: 'Hawaii',
    IA: 'Iowa',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    MA: 'Massachusetts',
    MD: 'Maryland',
    ME: 'Maine',
    MI: 'Michigan',
    MN: 'Minnesota',
    MO: 'Missouri',
    MP: 'Northern Mariana Islands',
    MS: 'Mississippi',
    MT: 'Montana',
    NC: 'North Carolina',
    ND: 'North Dakota',
    NE: 'Nebraska',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NV: 'Nevada',
    NY: 'New York',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    PR: 'Puerto Rico',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TT: 'Trust Territories',
    TX: 'Texas',
    UT: 'Utah',
    VA: 'Virginia',
    VI: 'Virgin Islands',
    VT: 'Vermont',
    WA: 'Washington',
    WI: 'Wisconsin',
    WV: 'West Virginia',
    WY: 'Wyoming',
});
/** Includes states and territories */
exports.US_STATE_NAME_TO_CODE = Object.freeze((0, lodash_1.invert)(exports.US_STATE_CODE_TO_NAME));
/** Contains ONLY US states, use US_STATE_TERRITORY_CODES for states and territories  */
exports.US_STATE_CODES = [
    'AK',
    'AL',
    'AR',
    'AZ',
    'CA',
    'CO',
    'CT',
    'DE',
    'FL',
    'GA',
    'HI',
    'IA',
    'ID',
    'IL',
    'IN',
    'KS',
    'KY',
    'LA',
    'MA',
    'MD',
    'ME',
    'MI',
    'MN',
    'MO',
    'MS',
    'MT',
    'NC',
    'ND',
    'NE',
    'NH',
    'NJ',
    'NM',
    'NV',
    'NY',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VA',
    'VT',
    'WA',
    'WI',
    'WV',
    'WY',
];
exports.US_TERRITORY_CODES = [
    'AS', // American Samoa
    'DC', // District of Columbia
    'GU', // Guam
    'MP', // Northern Mariana Islands
    'PR', // Puerto Rico
    'TT', // Trust Territories
    'VI', // Virgin Islands
];
/** 2-letter Codes of US States and territories in alphabetical order */
exports.US_STATE_TERRITORY_CODES = (0, sort_1.sort)(exports.US_STATE_CODES.concat(exports.US_TERRITORY_CODES));
